import { useState, useRef, useEffect } from "react";
import videoHero from "Assets/video-drone.mp4";
import posterVideo from "Assets/images/poster-video.jpg";
import "./Hero.scss";

const Hero = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    if (video.readyState >= 3) {
      setIsVideoLoaded(true);
    } else {
      const handleLoadedData = () => setIsVideoLoaded(true);
      video.addEventListener("loadeddata", handleLoadedData);

      return () => {
        video.removeEventListener("loadeddata", handleLoadedData);
      };
    }
  }, []);

  return (
    <section className="hero">
      {!isVideoLoaded && (
        <img
          src={posterVideo}
          width={1920}
          height={1080}
          alt="Fondo de Hero"
          className="poster-video"
        />
      )}
      <video
        playsInline
        loop
        autoPlay
        muted
        ref={videoRef}
        className={`video-hero ${isVideoLoaded ? "visible" : "hidden"}`}
        preload="auto"
        onLoadedData={() => {
          setIsVideoLoaded(true);
        }}
      >
        <source src={videoHero} type="video/mp4" />
        Tu navegador no admite la reproducción de videos.
        <code>video</code>.
      </video>
    </section>
  );
};

export default Hero;
